// services/axios.js
import axios from "axios";
import TokenService from "@/services/TokenService";
import {tokenExpired} from "@/store/features/authSlice.js"; // Ajoutez cette importation

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 30000,
});

api.interceptors.request.use(config => {
    const token = TokenService.getToken(); // Utiliser TokenService
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    res => res,
    err => {
        if (err.response?.status === 401) {
            console.log("Token invalide ou expiré - 401");

            // Vérifier si le token est vraiment expiré
            const token = TokenService.getToken();
            if (!token || !TokenService.isValidToken(token)) {
                // Dispatch l'action tokenExpired
             //   store.dispatch(tokenExpired());

                // Rediriger seulement si pas déjà sur login
                if (!window.location.pathname.includes('/login')) {
                    const currentPath = window.location.pathname + window.location.search;
                    window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}&reason=token_expired`;
                }
            }
        }

        // Gérer les autres erreurs
        if (err.response?.status === 403) {
            window.location.href = '/unauthorized';
        }

        return Promise.reject(err);
    }
);

export default api;